// Module
var code = `<!-- STRUCTURAL API -->
<section class="structural-api" aria-labelledby="structural-headline">

    <div class="structural-api__inner">

        <header class="structural-api__header">
            <p class="structural-api__label">The Structural API</p>
            <h2 id="structural-headline" class="structural-api__headline">
                Every layer of your application.<br>Visible before the first prompt.
            </h2>
            <p class="structural-api__sub">
                The Structural API generates a <strong>Structural Code Map</strong> — a complete,
                machine-readable view of your application's structure, relationships, and behavior.
                AI agents read it before touching a single file. No guesswork. No full codebase scan.
                Precise mutations only.
            </p>
            <p class="structural-api__distinction">
                Unlike AI-inferred code analysis tools, the Structural Code Map is emitted natively
                by the framework — ground truth, not interpretation, always current as the application runs.
            </p>
        </header>

        <ul class="structural-api__components" aria-label="Structural Code Map components">
            <li class="structural-api__component">
                <span class="structural-api__component-title">Structure</span>
                <span class="structural-api__component-desc">Application hierarchy and composition</span>
            </li>
            <li class="structural-api__component">
                <span class="structural-api__component-title">Relationships</span>
                <span class="structural-api__component-desc">How views, channels, and traits connect</span>
            </li>
            <li class="structural-api__component">
                <span class="structural-api__component-title">Behavior wiring</span>
                <span class="structural-api__component-desc">Events, actions, and channel bindings</span>
            </li>
<!--            <li class="structural-api__component">
                <span class="structural-api__component-title">Lifecycle</span>
                <span class="structural-api__component-desc">When and how each view initializes</span>
            </li>-->
            <li class="structural-api__component">
                <span class="structural-api__component-title">View hierarchy</span>
                <span class="structural-api__component-desc">Persistent and route-driven view tree</span>
            </li>
            <li class="structural-api__component">
                <span class="structural-api__component-title">Channels</span>
                <span class="structural-api__component-desc">Behavior boundaries and event flow</span>
            </li>
            <li class="structural-api__component">
                <span class="structural-api__component-title">Traits</span>
                <span class="structural-api__component-desc">Logic modules and their scope</span>
            </li>
        </ul>

        <figure class="structural-api__codemap">
            <div class="structural-api__codemap-bar">
                <div class="structural-api__codemap-bar-left">
          <span class="structural-api__window-dots" aria-hidden="true">
            <span class="structural-api__dot structural-api__dot--red"></span>
            <span class="structural-api__dot structural-api__dot--yellow"></span>
            <span class="structural-api__dot structural-api__dot--green"></span>
          </span>
                    <span class="structural-api__codemap-title">Structural Code Map — live output</span>
                    <span class="structural-api__codemap-badge">Valid JSON · Alpha</span>
                </div>
            </div>
            <div class="structural-api__codemap-body">
                <img
                        src="https://assetscontainer.com/temp/spyne-docs/images/code-map-prototype.png"
                        alt="SpyneJS Structural Code Map — a live tree visualization of application hierarchy, behavior wiring, channels, lifecycle, and replaceable targets emitted natively by the framework"
                        class="structural-api__codemap-image"
                        loading="lazy"
                        decoding="async"
                >
<!--
                <div class="structural-api__codemap-fade" aria-hidden="true"></div>
-->
            </div>
            <figcaption class="structural-api__codemap-footer">
        <span class="structural-api__codemap-note">
          Structural Code Map generated from a live SpyneJS application —
          structure, channels, traits, and replaceable targets mapped in full
        </span>
                <span class="structural-api__codemap-stat">Ground truth · Not inferred · Always current</span>
            </figcaption>
        </figure>

        <ul class="structural-api__statements" aria-label="Key facts about the Structural Code Map">
            <li class="structural-api__statement">
                Agents read the Structural Code Map <strong>before making changes</strong> —
                not after scanning thousands of lines.
            </li>
            <li class="structural-api__statement">
                AI tools <strong>understand the application</strong> before touching code.
                Developers never have to explain the codebase again.
            </li>
            <li class="structural-api__statement">
                The bigger the application, the <strong>more valuable the Structural Code Map
                becomes</strong> — precisely when legacy frameworks create the most agent confusion.
            </li>
            <li class="structural-api__statement">
                Load templates, styles, traits, and data <strong>only when a requested mutation
                requires them.</strong> No waste. No guesswork.
            </li>
        </ul>

        <div class="structural-api__cta">


            <a
                    data-channel="ROUTE"
                    data-event-prevent-default="true"
                    data-page-id="docs"
                    data-text="Docs"
                    href="/docs"

                    class="btn btn--secondary">Read the docs</a>





        </div>

    </div>

</section>
`;
// Exports
module.exports = code;